<template>
  <v-container fill-height>
    <v-layout row align-center>
      <v-flex class="text-xs-center xs12 sm6 offset-sm3">
        <v-card>
          <v-form>
            <v-card-title>
              <h3>Verify 2FA</h3>
            </v-card-title>
            <v-card-text class="text-xs-center xs12 sm6 offset-sm3">
              <v-text-field prepend-icon="lock" name="otpToken" label="2FA Token" v-model="otpToken"/>
            </v-card-text>
            <v-card-actions>
              <v-btn primary large block @click="verifyOTP">Validate</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
// import bus from '@/bus'

import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [APIMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      otpToken: ''
    }
  },

  mounted () {
  },

  methods: {
    async verifyOTP () {
      try {
        let result = await this.api({
          method: 'post',
          url: `/users/otp`,
          data: {otp_token: this.$data.otpToken}
        })

        this.$cookie.set('token', result.data.token)
        this.$router.push('/dashboard')
      } catch (err) {
        this.$store.commit('error', err)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OTPVerify.vue